import { TENANTS } from "../../constants"
import { useLegalMentions } from "../../hooks"
import { LegalsSection } from "../organisms/LegalsSection"
import { BplsFooter } from "../organisms/bpls"
import React from "react"
import { Col, Row } from "react-bootstrap"

export default function Footer({ tunnelData }) {
  const {
    tenant,
    data: {
      order: { shareCapitalFinancer, shareCapital }
    }
  } = tunnelData
  const { legalsToDisplay } = useLegalMentions(tunnelData)
  if (tenant === TENANTS.BPLS) return <BplsFooter tunnelData={tunnelData} />

  return (
    <footer>
      <Row className="rowFooter padding-45">
        <Col>
          <LegalsSection
            legalsToDisplay={legalsToDisplay}
            shareCapitalFinancer={shareCapitalFinancer}
            shareCapitalGroup={shareCapital}
            tunnelData={tunnelData}
          />
        </Col>
      </Row>
    </footer>
  )
}
